/**
 * 消息列表管理api
 */
import * as API from '../../'
import $const from '../../../common/constant'

export default {

  listByUser: params => {
    return API.GET($const.apiServer.CMS+'/eMeetingMessage/listByUser', params);
  },
  //未读消息数量查询
  notReadNumber: () => {
    return API.GET($const.apiServer.CMS+'/eMeetingMessage/notReadNumber',);
  },
  getById:id=>{
    return API.GET($const.apiServer.CMS+'/eMeetingMessage/getById?id='+id);
  },
  updateIsSee: params => {
    return API.POST($const.apiServer.CMS+'/eMeetingMessage/updateIsSee',params);
  },
}



// WEBPACK FOOTER //
// ./src/api/security/target/api_meeting_message.js